/** Ширина постоянного сайдбара админки — должна совпадать с отступом основной колонки (MUI Drawer permanent = fixed). */
export const ADMIN_DRAWER_WIDTH = 260;

/** Ширина свёрнутого сайдбара (только иконки). */
export const ADMIN_DRAWER_COLLAPSED_WIDTH = 72;

/** localStorage: «1» — свёрнут, «0» или отсутствует — развёрнут. */
export const ADMIN_SIDEBAR_COLLAPSED_STORAGE_KEY = 'playbase.admin.sidebarCollapsed';

export function getAdminDrawerWidth(collapsed) {
  return collapsed ? ADMIN_DRAWER_COLLAPSED_WIDTH : ADMIN_DRAWER_WIDTH;
}

/** Максимальная ширина контента страниц админки (как в adminStyles). */
export const ADMIN_CONTENT_MAX_WIDTH = 1400;
